export default __webpack_public_path__ + "static/media/placeholder_blank-fr-mobile.b5ecfb74.png";